import ChartParametersFormattingStrategy from './ChartParametersFormattingStrategy'
import DateRangeFormattingStrategy from '../../../parametersFormatting/DateRangeFormattingStrategy'

export default class WorkingHoursCostBillingParametersFormattingStrategy extends ChartParametersFormattingStrategy {
    init({selectorsData, dateFormat, reportAuthorizationInfo}) {
        super.init({selectorsData, dateFormat, reportAuthorizationInfo})
        return this
    }

    createDateParametersFormattingStrategy(config) {
        return new DateRangeFormattingStrategy(config.dateFormat)
    }

    formatParametersText(selectedParameters) {
        return this.parametersFormatter.formatUsersSelection(selectedParameters.hierarchicalSelectorsParameters.userSelection) +
               "; " +
               this.parametersFormatter.formatCustomersAndProjectsSelection(selectedParameters.hierarchicalSelectorsParameters.customersProjectsSelection)
    }
}



// WEBPACK FOOTER //
// ./web/js/reports/charts/parametersFormatters/WorkingHoursCostBillingParametersFormattingStrategy.js